export default __webpack_public_path__ + "img/logout.1fc1e701.svg";